import React from 'react';
import { useDispatch } from 'react-redux';
import { toggleItemSelection } from '../../../../data/reducers/resolveViolationsReducer';
import './ResolveViolationsCard.css';

/**
 * Card component for displaying a single violation/complaint item.
 * Matches the email template design.
 *
 * @param {Object} props Component props
 * @param {Object} props.item Item data
 * @param {boolean} props.isSelected Whether item is selected
 */
const ResolveViolationsCard = ({ item, isSelected }) => {
	const dispatch = useDispatch();

	const handleToggle = () => {
		dispatch(toggleItemSelection(item.queued_email_id));
	};

	// Split display values into two columns (like email)
	const displayEntries = Object.entries(item.display_values || {});
	const mid = Math.ceil(displayEntries.length / 2);
	const leftPairs = displayEntries.slice(0, mid);
	const rightPairs = displayEntries.slice(mid);

	return (
		<div className="resolve-violations-card">
			<div className="card-checkbox">
				<input
					type="checkbox"
					checked={isSelected}
					onChange={handleToggle}
					aria-label={`Select ${item.dataset_name} for ${item.property_address}`}
				/>
			</div>

			<div className="card-content">
				{/* Property Address Header */}
				<div className="card-header">
					<div className="building-icon">
						<svg
							width="20"
							height="20"
							viewBox="0 0 24 24"
							fill="none"
							stroke="currentColor"
							strokeWidth="2"
						>
							<path d="M3 21h18M9 8h1m-1 4h1m-1 4h1m4-8h1m-1 4h1m-1 4h1M5 21V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16" />
						</svg>
					</div>
					<h3>{item.property_address}</h3>
				</div>

				{/* Dataset Type Badge */}
				<div className="dataset-badge">
					<div className="badge-icon">⚠</div>
					<div className="badge-text">{item.dataset_name}</div>
				</div>

				{/* Display Values (Two Column Layout like Email) */}
				<div className="card-details">
					<div className="details-left">
						{leftPairs.map(([label, value]) => (
							<div key={label} className="detail-item">
								<span className="detail-label">{label}</span>
								<span className="detail-value">{value || 'N/A'}</span>
							</div>
						))}
					</div>
					<div className="details-right">
						{rightPairs.map(([label, value]) => (
							<div key={label} className="detail-item">
								<span className="detail-label">{label}</span>
								<span className="detail-value">{value || 'N/A'}</span>
							</div>
						))}
					</div>
				</div>

				{/* Status and Changes Footer */}
				{(item.change_description || item.status) && (
					<>
						<hr className="card-divider" />
						<div className="card-footer">
							{item.change_description && (
								<>
									<span className="footer-label">Changes: </span>
									<span className="footer-change">
										{item.change_description}
									</span>
								</>
							)}
							{item.change_description && item.status && (
								<span className="footer-separator">|</span>
							)}
							{item.status && (
								<>
									<span className="footer-label">Status: </span>
									<span className="footer-status">{item.status}</span>
								</>
							)}
						</div>
					</>
				)}
			</div>
		</div>
	);
};

export default ResolveViolationsCard;
